"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.composeTokensForHeaderValue = exports.getTokensFromHeaderValue = void 0;
/**
 * Retrieve the tokens from the given `Authorization` header value.
 */
const getTokensFromHeaderValue = (header) => {
    const tokens = [];
    const entries = header.trim().split(',');
    for (const entry of entries) {
        const type = entry.trim().substring(0, 6).toLowerCase();
        const value = entry.trim().substring(7).trim();
        if (type.trim().toLowerCase() !== 'bearer') {
            return undefined;
        }
        tokens.push(value);
    }
    return tokens;
};
exports.getTokensFromHeaderValue = getTokensFromHeaderValue;
/**
 * Compose a header value for the `Authorization` header.
 */
const composeTokensForHeaderValue = (tokens) => {
    const values = [];
    if (tokens?.admin !== undefined) {
        values.push(`Bearer ${tokens.admin}`);
    }
    if (tokens?.actor !== undefined) {
        values.push(`Bearer ${tokens.actor}`);
    }
    if (values.length >= 1) {
        return values.join(', ');
    }
    return undefined;
};
exports.composeTokensForHeaderValue = composeTokensForHeaderValue;
